import { AbstractControl } from '@angular/forms';
import { Store } from '@ngxs/store';
import { StandardListenerPlugin } from '@controls/core/standard-listener-plugin-template';
import { ErrorMessengerService } from '@records/controls/services/error-messenger.service';
import { merge, Observable } from 'rxjs';
import { auditTime, filter, tap } from 'rxjs/operators';

export const __ErrorMessengerConnectedSymbol = Symbol('__ErrorMessengerConnectedSymbol');

export abstract class AbstractErrorMessengerListener<C> extends StandardListenerPlugin<C> {
  constructor(protected store: Store) {
    super();
  }

  /**
   *
   * @param config
   * @param ctrl
   * @param _ form
   * @param valueChanges$
   * @returns
   */
  connect(config: C, ctrl: AbstractControl, _: AbstractControl): Observable<any> {
    // if listener has not been set up for ctrl, then attach
    const errorMessengerService = this.makeErrorService(config);
    // merge value changes with status changes to evaluate and emit on either change
    const errorMessengerListener$ = merge(ctrl.valueChanges, ctrl.statusChanges).pipe(
      // emit only if control has been touched and status is not pending
      filter(() => ctrl.status !== 'PENDING'),
      // Ignore for 500ms and then emit last captured value
      auditTime(500),
      // tick errors
      tap(() => this.tickErrors(ctrl, errorMessengerService))
    );
    // trigger initial value validity
    ctrl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    this.tickErrors(ctrl, errorMessengerService);
    this.markAsConnected(ctrl);
    return errorMessengerListener$;
  }

  public tickErrors(ctrl: AbstractControl, errorMessengerService: ErrorMessengerService) {
    // clear or register errors
    if (ctrl.errors == null || !Object.keys(ctrl.errors).length) {
      errorMessengerService.clearErrors(ctrl.errors);
    } else {
      errorMessengerService.registerErrors(ctrl.errors);
    }
  }

  protected abstract makeErrorService(config: C): ErrorMessengerService;
}
